module.exports = __webpack_public_path__ + "img/m.70b0d96c.jpg";